/**
 * Copyright © 2026 Adnuntius AS.
 */
import {LocalStorage} from "./local-storage";
import * as _ from "lodash";
import {Injectable} from '@angular/core';

const ONE_HOUR = 60 * 60 * 1000;
const TEN_MINUTES = 10 * 60 * 1000;

type InactiveTargets = {
  timing: number;
  data: any;
};

@Injectable({providedIn: 'root'})
export class LocalInactiveTargets {
  private static readonly INACTIVE_TARGETS = 'inactiveTargets';

  inactiveTargets: InactiveTargets;

  constructor() {
    this.refresh();
  }

  private save() {
    LocalStorage.obtain().setItem(LocalInactiveTargets.INACTIVE_TARGETS, this.inactiveTargets);
  }

  private refresh() {
    const localStorageInfo = LocalStorage.obtain().getItem(LocalInactiveTargets.INACTIVE_TARGETS);
    this.inactiveTargets = _.isEmpty(localStorageInfo) ? _.isEmpty(this.inactiveTargets) ? {} : this.inactiveTargets : localStorageInfo;
  }

  setInactiveTargets(inactiveTargets?: any) {
    this.inactiveTargets.timing = Date.now();
    this.inactiveTargets.data = inactiveTargets || null;
    this.save();
  }

  clear(): void {
    this.inactiveTargets = {timing: 0, data: null};
    LocalStorage.obtain().remove(LocalInactiveTargets.INACTIVE_TARGETS);
  }

  getInactiveTargets(forceCall?: boolean): any {
    this.refresh();
    if ((!forceCall || (forceCall && Date.now() - TEN_MINUTES < this.inactiveTargets.timing)) && this.inactiveTargets.data && (Date.now() - ONE_HOUR < this.inactiveTargets.timing)) {
      return this.inactiveTargets.data;
    }
    return null;
  }
}
